<div class="container navtop">

    <h2 *ngIf="stationDetail?.available === 1" class="col-12 primary-font"><b>Je recharge mon véhicule</b></h2>
    <h1 *ngIf="stationDetail?.available === -1" class="col-12 primary-font"><b>Point de charge en veille </b></h1>

    <h4 *ngIf="stationDetail?.available === -1" class="col-12 mt-2"><b>Réveillez la borne en passant n’importe quel badge RFID (Navigo, CB sans contact …) sur la borne puis actualisez la page</b></h4>

    <!-- spinner -->
    <div *ngIf="IsWait" class="col-12">
        <div class="row justify-content-center mt-4">
            <mat-spinner class="mt-5" strokeWidth="19" [diameter]="100" color="primary"></mat-spinner>
        </div>
    </div>


    <div *ngIf="!IsWait">

        <div class="row justify-content-center">
            <mat-card class="col-11 col-lg-7">
                <mat-card-content>

                    <h3 class="text-center"><b>Détails de la station</b></h3>

                    <h4 class="col-12"><b>{{stationDetail?.name}}</b></h4>



                    <h4 class="col-12">{{stationDetail?.street}}, {{stationDetail?.zipcode}}
                        {{stationDetail?.city}}</h4>

                    <h4 class="col-12">{{stationDetail?.price.description_price}}</h4>


                    <div class="row justify-content-center">

                        <img mat-card-image class="col-6" style="margin-bottom: 0px !important;"
                            [src]="sanitizeImageUrl('data:'+stationDetail?.image.mimetype+';base64,'+stationDetail?.image.file)"
                            alt="clem">


                    </div>


                </mat-card-content>
            </mat-card>



        </div>



        <form [formGroup]="formGroup">



            <!---------------------------------- Identifiant ---------------------------------------->
            <div *ngIf="stationDetail?.available === 1" class="row justify-content-center mt-4">
                <mat-card class="col-11 col-lg-7 bordure">
                    <mat-card-content>

                        <h2 class="row justify-content-center primary-font"><b>Vos identifiants</b></h2>


                        <h5 style="color: red;">*Choisissez un code à 4 chiffres facile à mémoriser. Vous en aurez
                            besoin pour Lancer/Arrêter votre recharge.</h5>


                        <!-- code pin -->
                        <div class="row justify-content-center">
                            <mat-form-field class="col-10">
                                <input matInput placeholder="Code PIN Magique :" formControlName="pin"
                                    [type]="hide ? 'password' : 'number'" required>
                                <mat-icon style="cursor: pointer" matSuffix (click)="hide = !hide">{{hide ?
                                    'visibility_off' : 'visibility'}}</mat-icon>
                                <mat-error
                                    *ngIf="!formGroup.controls['pin'].valid || formGroup.controls['pin'].touched">
                                    {{ getErrorPassword() }}
                                </mat-error>
                            </mat-form-field>
                        </div>




                        <!-- Numéro de téléphone -->
                        <div class="row justify-content-center">
                            <mat-form-field class="col-10">
                                <input matInput placeholder="Numéro de téléphone :" formControlName="phonenumber"
                                    required>
                                <mat-error
                                    *ngIf="!formGroup.controls['phonenumber'].valid || formGroup.controls['phonenumber'].touched">
                                    {{ getErrorPhonenumber() }}
                                </mat-error>
                            </mat-form-field>
                        </div>



                        <!-- Adresse email -->
                        <div class="row justify-content-center">
                            <mat-form-field class="col-10">
                                <input matInput placeholder="Adresse E-mail (pour recevoir la facture) :"
                                    formControlName="email">
                                <mat-error
                                    *ngIf="!formGroup.controls['email'].valid || formGroup.controls['email'].touched">
                                    {{ getErrorEmail() }}
                                </mat-error>
                            </mat-form-field>
                        </div>








                    </mat-card-content>
                </mat-card>


            </div>


          


            <!-------------------------------- bouton ----------------------------------->
            <div *ngIf="stationDetail?.available === 1" class="row justify-content-center mt-4">
                <button class="col-11 col-md-3 primary-bouton " mat-raised-button color="primary" (click)="signUp()"
                    type="submit" type="submit">Suivant</button>
            </div>




        </form>


    </div>



</div>